import { Component, Prop, h, Element, Host, Watch } from '@stencil/core';
@Component({
  tag: 'pn-illustration',
  styleUrl: 'pn-illustration.scss',
})
export class PnIllustration {
  @Element() hostElement: HTMLElement;

  /** The SVG content of the illustration you want to use. The viewBox property will be used to determine width/height */
  @Prop() illustration!: string;
  /** Set the width of the SVG element. Any valid CSS width value is allowed */
  @Prop({ mutable: true }) width?: string;
  /** Set the height of the SVG element. Any valid CSS height value is allowed */
  @Prop({ mutable: true }) height?: string;

  /** Make the SVG fill to its parent size (sets width/height 100% and `display: block` instead of `inline-block`) */
  @Prop() fill?: boolean = false;
  @Watch('fill')
  handleFill() {
    if (this.fill) {
      this.width = '100%';
      this.height = '100%';
    }
  }

  componentWillRender() {
    this.handleFill();
    if (this.width || this.height) return this.setSizes();
    this.getSizeFromSvg();
  }

  componentDidRender() {
    this.hostElement.querySelector('svg')?.setAttribute('width', this.width);
    this.hostElement.querySelector('svg')?.setAttribute('height', this.height);
  }

  getSizeFromSvg() {
    const viewBox = this.illustration?.match(/<svg[^>]*?viewBox=(["\'])?((?:.(?!\1|>))*.?)\1?/)?.[2];

    if (!viewBox) return;

    const [, , width = '', height = ''] = viewBox?.split(' ') || [];

    if (!width || !height) return;

    this.width = `${Number(width)}px`;
    this.height = `${Number(height)}px`;

    this.setSizes();
  }

  setSizes() {
    this.hostElement.style.setProperty('--pn-width', this.width);
    this.hostElement.style.setProperty('--pn-height', this.height);
  }

  render() {
    return <Host role="presentation" innerHTML={this.illustration} data-fill={this.fill}></Host>;
  }
}
